import moment from "moment";

// todo improve naming
export const formatTime = (hours: number): string => {
  const midnight = moment().startOf("day");
  midnight.add(hours, "hours");
  return midnight.format("H[h] mm[m]");
};
